<template>
    <div>
    <a v-if="canClear" href="#" @click="removeAllAnnouncements">clear all</a>
    <ul class="list-group">
        <li class="list-group-item" v-for="a in sortedAnnouncements" :key="a.id"> 
            <div class="d-flex flex-direction:row justify-content-between">
                <p class="text-left">{{ a.text }} </p>
                <button v-if="isAdmin || isOwner(a)" @click="removeAnnouncement(a.id)" class="btn btn-sm btn-danger align-self-start py-0 ml-1 rounded-circle"> x </button>
            </div>
            <div class="d-flex flex-direction:row justify-content-start">
                <small class="font-italic">{{ a.user.name }}</small>
            </div>
        </li>
    </ul>
    </div>
</template>


<script>
import { db } from '@/main.js'

export default {
    name: "AnnounceList",
    data () {
        return {
            announcements: [],
        }
    },
    firestore () {
        return {
            announcements: db.collection('announcements'),
        }
    },
    computed: {
        sortedAnnouncements: function () {
            var filtered = this.announcements.slice().filter(a => a.org === this.$root.sharedState.org)
            var sorted = filtered.slice().sort((a,b) => b.date > a.date)
            return sorted
        },
        isAdmin: function () {
            return this.$root.sharedState.isAdmin
        },
        canClear: function () {
            return this.$root.sharedState.accessLevel > 4
        }
    },
    methods: {
        removeAnnouncement: function (id) {
            this.$firestoreRefs.announcements.doc(id).delete();
        },
        removeAllAnnouncements: function() {
            this.announcements.forEach((announcement) => {
                if (announcement.org === this.$root.sharedState.org) {
                    this.$firestoreRefs.announcements.doc(announcement.id).delete();
                }
            })
        },
        isOwner: function (announcement) {
            return this.$root.sharedState.uid == announcement.user.uid
        },
    },
}
</script>
